import React, { Component, PropTypes } from 'react';
import AppPage from 'components/AppPage';
import RulerBar from 'components/RulerBar';
import NotificationActions from 'actions/Notification';
import NotificationDetailActions from 'actions/NotificationDetail';
import NotificationDetailStore from 'stores/NotificationDetail';
import AppStore from 'stores/App';
import { mixin, RefluxMixin, Authorizer } from 'Util';
import ListDetail from 'components/Material/ListDetail';
import ListItem from 'components/Material/ListItem';
import * as Icons from 'components/Icons';
import { NOTIFICATIONS as notificationTypes, notificationPageLength } from 'Constants';

import { Styles, RaisedButton } from 'material-ui';

import { getNotifications } from 'selectors/notificationDetail';

const { Transitions, Colors } = Styles;

let notificationIcons = {};
notificationIcons[notificationTypes.NOTIFICATION_ADDED_TO_CIRCLE] =
  'ModuleDiscussion';
notificationIcons[notificationTypes.NOTIFICATION_TASK_FEEDBACK] = 'ModuleTask';
notificationIcons[notificationTypes.NOTIFICATION_DRIP_CONTENT] =
  'ModuleTask';
notificationIcons[notificationTypes.NOTIFICATION_POST_ADDED] =
  'ModuleDiscussion';
notificationIcons[notificationTypes.NOTIFICATION_TASK_ASSESSED] = 'ModuleTask';
notificationIcons[notificationTypes.NOTIFICATION_YOU_MENTIONED] =
  'ModuleDiscussion';
notificationIcons[notificationTypes.NOTIFICATION_FEEDBACK_REQUIRED] =
  'ModuleInteraction';
notificationIcons[notificationTypes.NOTIFICATION_UNREVIEWED_TASKS] =
  'ModuleTask';
notificationIcons[notificationTypes.NOTIFICATION_THREAD_NEW_POSTS] =
  'ModuleDiscussion';
notificationIcons[notificationTypes.NOTIFICATION_COURSE_NEW_POSTS] =
  'ModuleDiscussion';
notificationIcons[notificationTypes.NOTIFICATION_COURSE_SOLD] =
  'ModuleDiscussion';
notificationIcons[notificationTypes.NOTIFICATION_COURSE_PACKAGE_SOLD] =
  'ModuleDiscussion';
notificationIcons[notificationTypes.NOTIFICATION_ADDED_TO_COURSE] =
  'ModuleDiscussion';
notificationIcons[notificationTypes.NOTIFICATION_DATA_EXPORT] =
  'ModuleDiscussion';
notificationIcons[notificationTypes.NOTIFICATION_COURSE_INVITE] =
  'ModuleDiscussion';
notificationIcons[notificationTypes.NOTIFICATION_BROADCAST] =
  'ModuleDiscussion';

export default class Communication extends mixin(
  RefluxMixin,
  Authorizer,
  Component
) {
  static contextTypes = {
    getIntlMessage: PropTypes.func,
  };

  static defaultProps = {
    filter: [
      { payload: 'all', types: [-1], text: 'New' },
      { payload: 'task', types: [2, 4, 6, 7], text: 'Tasks' },
      { payload: 'discussion', types: [3, 5, 8, 9], text: 'Discussions' },
      { payload: 'sales', types: [10, 11], text: 'Sales' },
      { payload: 'archive', types: [-1], text: 'Archive' },
    ],
  };

  constructor() {
    super(...arguments);
    var types = {};
    types[-1] = true;
    this.state = {
      filter: {},
      page: 0,
      types,
    };
  }

  listenToStores() {
    this.listenToStore(AppStore, 'app');

    this.listenToStoreWithMapper(NotificationDetailStore, (state) => {
      return {
        notificationsLoading: state.notifications.loading,
        notificationsPrevDisabled: state.notifications.pageStart < 1,
        notificationsNextDisabled: false,
        pageStartNotifications: state.notifications.pageStart,
        pageLengthNotifications: state.notifications.pageLength,
        notifications: getNotifications(state),
        ...this.mapActions({
          prevNotifications: NotificationDetailActions.prevNotifications,
          nextNotifications: NotificationDetailActions.nextNotifications,
        }),
      };
    });
  }

  filter = async (filter) => {
    var types = {};
    filter.types.forEach((type) => {
      types[type] = true;
    });
    if (
      this.state.filter.payload === 'archive' ||
      filter.payload === 'archive'
    ) {
      await NotificationDetailActions.read(true);
      this.setState({ types, filter });
    } else {
      this.setState({ types, filter });
    }
  };

  componentDidMount() {
    if (super.componentDidMount) {
      super.componentDidMount();
    }

    NotificationDetailActions.read(false);
    // NotificationActions.read();
    this.filter({ payload: 'all', types: [-1], text: 'New' });
  }

  markRead = (item) => {
    NotificationActions.markRead([item.id]);
  };

  sayHi(message) {}

  getItemStyle() {
    let style = {};
    return style;
  }

  createListItem = (item, leftAvatar, insetChildren) => {
    const { filter } = this.state;
    let style = this.getItemStyle();
    if (this.state.selected && item.id === this.state.selected.id) {
      //style.backgroundColor = this.context.muiTheme.rawTheme.palette.primary3Color;
      style.backgroundColor = Colors.Colors.grey[300].material;
    }

    const filterPayload = this.state.filter.payload || '';
    let TypeIcon = Icons[notificationIcons[item.type]];

    return (
      <ListItem
        key={item.id}
        payload={filterPayload}
        item={item}
        filter={filter}
        leftIcon={<TypeIcon />}
        dangerouslySetInnerHTML={{ __html: item.message }}
        onNavigateTouchTap={this.markRead}
      />
    );
  };

  prev = () => {
    this.setState({ page: this.state.page - 1 });
    NotificationDetailActions.read(this.state.page);
  };

  next = () => {
    this.setState({ page: this.state.page + 1 });
    NotificationDetailActions.read(this.state.page);
  };

  render() {
    let filterFunc, detail;
    const { types, filter } = this.state;
    const {
      notifications,
      notificationsLoading,
      prevNotifications,
      nextNotifications,
      notificationsPrevDisabled,
      notificationsNextDisabled,
      pageStartNotifications,
      pageLengthNotifications,
    } = this.state;

    filterFunc = (item, searchText, labelProperty) => {
      let filtered;
      if (this.state.filter.payload === 'task') {
        filtered = [2, 4, 6, 7].includes(item.type);
      } else if (this.state.filter.payload === 'discussion') {
        filtered = [3, 5, 8, 9].includes(item.type);
      } else if (this.state.filter.payload === 'archive' && item.isRead) {
        filtered = true;
      } else if (this.state.filter.payload === 'all' && !item.isRead) {
        filtered = true;
      } else {
        filtered = [10,11].includes(item.type);
      }
      if (searchText !== null) {
        return (
          filtered && item[labelProperty].toUpperCase().search(searchText) > -1
        );
      } else {
        return filtered;
      }
    };
    const newNotifications = notifications.filter(el => el.isRead === 0);
    const pagination = (
      <div>
        <RaisedButton
          secondary
          disabled={pageStartNotifications < 2}
          onClick={NotificationDetailActions.prevNotifications}
          label="back"
        />
        <RaisedButton
          secondary
          disabled={
            filter.text === 'New' ? newNotifications.length < notificationPageLength : notifications.length < notificationPageLength
          }
          onClick={NotificationDetailActions.nextNotifications}
          label="next"
        />
      </div>
    );

    return (
      <AppPage
        header={
          <RulerBar title={this.context.getIntlMessage('menu.Notification')} />
        }>
        <ListDetail
          pagination={!notificationsLoading && pagination}
          filter={filterFunc}
          filtering={filter}
          containerStyle={{ bottom: '75px' }}
          types={types}
          divider={false}
          listItemGenerator={this.createListItem}
          dangerouslySetInnerHTML={true}
          onFilterChange={this.filter}
          items={notifications}
          labelProperty={'message'}
          filterOptions={this.props.filter}
          loading={notificationsLoading}
          prevDisabled={notificationsPrevDisabled}
          nextDisabled={notificationsNextDisabled}
          prev={prevNotifications}
          next={nextNotifications}
          pageStartNotifications={pageStartNotifications}
          pageLengthNotifications={pageLengthNotifications}>
          {detail}
        </ListDetail>
      </AppPage>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/Communication.js